import React from 'react';
import { Icon, } from './icons';
import { classNames, registerClass, subClass, } from '@food/css-manager';
var style = registerClass(function (theme, sc) { return "\n\tdisplay: inline-block;\n\t\n\t" + Object.keys(theme.colors)
    .filter(function (k) { return !!theme.colors[k].disabled; })
    .map(function (d) {
    return "&." + sc('type', d) + " {\n\t\t\tcolor: " + theme.colors[d].plain + ";\n\t\t}";
})
    .join(''); });
export var Toggle = function (_a) {
    var checked = _a.checked, onChange = _a.onChange, type = _a.type, className = _a.className;
    return (React.createElement("div", { className: classNames(className, style, checked && subClass(style, 'type', type)), onClick: function () { return onChange && onChange(!checked); } },
        React.createElement(Icon, { name: checked
                ? 'radio_button_checked'
                : 'radio_button_unchecked' })));
};
//# sourceMappingURL=Toggle.js.map